export default __webpack_public_path__ + "images/loggedout/home/modularPage/dark_blue_curve-e7cf3a548cce7fd4474b2ca335801da1.svg";